export const SEARCH_DEBOUNCE_DELAY_MS = 300;
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_SEARCH_STALE_TIME = 30_000;
export const MIN_SEARCH_QUERY_LENGTH = 2;
